import { axiosClientMiddleware } from "config/axios/AxiosClient"
import type { AxiosResponse, CancelToken } from "axios"
import OMNIX_MODULE from "constants/OMNIX_MODULE"
// import { Env, MultiClient } from "config"

// let [_client] = MultiClient.get_user_env(null, Env.clients, Env.env, Env.defaults)

interface IResponseService<TResult> {
  transactionId?: string
  code: number
  message: TResult
}

export const authorizerService = async (
  body: any,
  // cancelToken: CancelToken,
): Promise<AxiosResponse<any>> => {
  const response = await axiosClientMiddleware.post<IResponseService<any>>("osm/security/oauth2/token", body, {
    headers: { "Content-Type": "application/json" },
    // cancelToken,
  })

  return response
}

export const post_middleware_query = async (
  body: any,
  token: string,
  cancelToken: CancelToken,
): Promise<AxiosResponse<IResponseService<any>>> => {
  const response = await axiosClientMiddleware.post<IResponseService<any>>("query", body, {
    headers: { "Content-Type": "application/json", Authorization: token },
    cancelToken,
  })

  return response
}

export const post_middleware_osrm_search = async (
  entity: string,
  body: any,
  token: string,
  cancelToken?: CancelToken,
): Promise<AxiosResponse<IResponseService<any>>> => {
  if (entity === "series") {
    const url = `ws/series/search`
    return await axiosClientMiddleware.post<IResponseService<any>>(url, body, {
      headers: { "Content-Type": "application/json", Authorization: token },
      cancelToken,
    })
  }

  const url = `bff/osrm/search/${entity}`
  const response = await axiosClientMiddleware.post<IResponseService<any>>(url, body, {
    headers: { "Content-Type": "application/json", Authorization: token },
    cancelToken,
  })

  return response
}

export const put_middleware_series_update = async (
  id: string,
  body: any,
  token: string,
  email?: string,
  platform?: string,
  cancelToken?: CancelToken,
): Promise<AxiosResponse<IResponseService<any>>> => {
  const url = `ws/series/${id}`
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    Authorization: token,
  }
  if (email) headers["x-user-email"] = email
  if (platform) headers["x-platform"] = platform

  const response = await axiosClientMiddleware.put<IResponseService<any>>(url, body, {
    headers,
    cancelToken,
  })

  return response
}

/**
 * Actualización Masiva por Excel (por Categoría)
 * POST /ws/series/search/csv — multipart/form-data
 *   file: File (.xlsx / .xls)
 *   categories: "ALL" | JSON string array (opcional, por omisión = ALL)
 * Respuesta: { summary, total, updated, skipped, skippedDetails, ignoredByFilter,
 *              selectedCategories, bulkResult, ordenFechaCliente }
 *
 * TODO: Revertir a axiosClientMiddleware + ruta relativa cuando salga a producción.
 */
export const post_middleware_series_bulk_csv = async (
  file: File,
  token: string,
  categories?: string[] | "ALL",
): Promise<AxiosResponse<IResponseService<any>>> => {
  const formData = new FormData()
  formData.append("file", file)
  if (categories && categories !== "ALL") {
    formData.append("categories", JSON.stringify(categories))
  }
  const response = await axiosClientMiddleware.post<IResponseService<any>>(
    "ws/series/search/csv",
    formData,
    { headers: { "Content-Type": "multipart/form-data", Authorization: token } },
  )
  return response
}

export const post_middleware_series_create = async (
  body: any,
  token: string,
  email?: string,
  platform?: string,
  cancelToken?: CancelToken,
): Promise<AxiosResponse<IResponseService<any>>> => {
  const url = `ws/series`
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    Authorization: token,
  }
  if (email) headers["x-user-email"] = email
  if (platform) headers["x-platform"] = platform

  return await axiosClientMiddleware.post<IResponseService<any>>(url, body, {
    headers,
    cancelToken,
  })
}

export const get_middleware_bff = async <T>(
  path: string,
  token?: string,
): Promise<AxiosResponse<IResponseService<T>>> => {
  const rootPath = `bff${path}`
  const userString = localStorage.getItem("USER_SIMO")
  let user: any = null
  if (userString) {
    try {
      user = JSON.parse(userString)
    } catch (error) {
      console.error("Error al parsear el usuario:", error)
    }
  }
  const response = await axiosClientMiddleware.get<IResponseService<T>>(rootPath, {
    headers: { "Content-Type": "application/json", Authorization: token ?? user?.token },
  })
  return response
}

export const get_business_rules = async (
  token?: string,
): Promise<AxiosResponse<any>> => {
  const userString = localStorage.getItem("USER_SIMO")
  let user: any = null
  if (userString) {
    try {
      user = JSON.parse(userString)
    } catch (error) {
      console.error("Error al parsear el usuario:", error)
    }
  }
  const response = await axiosClientMiddleware.get<any>("rules", {
    headers: { "Content-Type": "application/json", Authorization: token ?? user?.token },
  })
  return response
}

export const put_business_rules = async (
  body: any,
  token?: string,
): Promise<AxiosResponse<any>> => {
  const userString = localStorage.getItem("USER_SIMO")
  let user: any = null
  if (userString) {
    try {
      user = JSON.parse(userString)
    } catch (error) {
      console.error("Error al parsear el usuario:", error)
    }
  }
  const response = await axiosClientMiddleware.put<any>("rules", body, {
    headers: { "Content-Type": "application/json", Authorization: token ?? user?.token },
  })
  return response
}

export const post_middleware_bff = async <T>(
  path: string,
  body: any,
  token?: string,
): Promise<AxiosResponse<IResponseService<T>>> => {
  const rootPath = `bff${path}`
  const userString = localStorage.getItem("USER_SIMO")
  let user: any = null
  if (userString) {
    try {
      user = JSON.parse(userString)
    } catch (error) {
      console.error("Error al parsear el usuario:", error)
    }
  }
  const response = await axiosClientMiddleware.post<IResponseService<T>>(rootPath, body, {
    headers: { "Content-Type": "application/json", Authorization: token ?? user?.token },
  })
  return response
}

export const post_middleware_query_items = async (
  body: any,
  channel: string,
  token: string,
  cancelToken: CancelToken,
): Promise<AxiosResponse<IResponseService<any>>> => {
  const response = await axiosClientMiddleware.post<IResponseService<any>>(
    `orch/inventory/item/all/channel/${channel}?allProperties=true`,
    body,
    {
      headers: { "Content-Type": "application/json", Authorization: token },
      cancelToken,
    },
  )

  return response
}

export const post_add_trace_orders = async (
  orderId: string,
  body: any,
  token: string,
  // cancelToken: CancelToken,
): Promise<AxiosResponse<IResponseService<any>>> => {
  const response = await axiosClientMiddleware.post<IResponseService<any>>(`bff/trace/shippinggroup/${orderId}`, body, {
    headers: { "Content-Type": "application/json", Authorization: token },
  })
  return response
}

export const post_execute_actions_orders = async (
  body: any,
  token: string,
  // cancelToken: CancelToken,
): Promise<AxiosResponse<IResponseService<any>>> => {
  const response = await axiosClientMiddleware.post<IResponseService<any>>(`bff/execute/shippinggroup`, body, {
    headers: { "Content-Type": "application/json", Authorization: token },
  })
  return response
}

export const put_update_info_order_action = async (
  id: string,
  body: any,
  token: string,
  // cancelToken: CancelToken,
): Promise<AxiosResponse<IResponseService<any>>> => {
  const response = await axiosClientMiddleware.put<IResponseService<any>>(`update/${id}`, body, {
    headers: { "Content-Type": "application/json", Authorization: token },
  })
  return response
}

// Call API Developers -> https://developers.omnixsystem.com/

export const get_module_entity_action_middleware = async (
  group: OMNIX_MODULE,
  endpoint: string,
  params: any,
  token: string,
  cancelToken: CancelToken,
): Promise<AxiosResponse<IResponseService<any>>> => {
  const response = await axiosClientMiddleware.get<IResponseService<any>>(`bff/${group}/${endpoint}`, {
    params,
    headers: { "Content-Type": "application/json", Authorization: token },
    // cancelToken,
  })

  return response
}

export const get_module_entity_action_middleware_without_bff = async (
  group: OMNIX_MODULE,
  endpoint: string,
  params: any,
  token: string,
  cancelToken?: CancelToken,
): Promise<AxiosResponse<IResponseService<any>>> => {
  const response = await axiosClientMiddleware.get<IResponseService<any>>(`${group}/${endpoint}`, {
    params,
    headers: { "Content-Type": "application/json", Authorization: token },
    // cancelToken,
  })

  return response
}

export const post_module_entity_action_middleware = async (
  group: OMNIX_MODULE,
  endpoint: string,
  body: any,
  token: string,
  cancelToken: CancelToken,
): Promise<AxiosResponse<IResponseService<any>>> => {
  const response = await axiosClientMiddleware.post<IResponseService<any>>(`bff/${group}/${endpoint}`, body, {
    headers: { "Content-Type": "application/json", Authorization: token },
    // cancelToken,
  })

  return response
}

export const put_module_entity_action_middleware_without_bff = async (
  group: OMNIX_MODULE,
  endpoint: string,
  body: any,
  token: string,
  cancelToken: CancelToken,
): Promise<AxiosResponse<IResponseService<any>>> => {
  const response = await axiosClientMiddleware.put<IResponseService<any>>(`${group}/${endpoint}`, body, {
    headers: { "Content-Type": "application/json", Authorization: token },
    // cancelToken,
  })

  return response
}

export const put_module_entity_action_middleware = async (
  group: OMNIX_MODULE,
  endpoint: string,
  body: any,
  token: string,
  cancelToken: CancelToken,
): Promise<AxiosResponse<IResponseService<any>>> => {
  const response = await axiosClientMiddleware.put<IResponseService<any>>(`bff/${group}/${endpoint}`, body, {
    headers: { "Content-Type": "application/json", Authorization: token },
    // cancelToken,
  })

  return response
}

export const delete_module_entity_action_middleware = async (
  group: OMNIX_MODULE,
  endpoint: string,
  params: any,
  token: string,
  cancelToken: CancelToken,
): Promise<AxiosResponse<IResponseService<any>>> => {
  const response = await axiosClientMiddleware.delete<IResponseService<any>>(`bff/${group}/${endpoint}`, {
    params,
    headers: { "Content-Type": "application/json", Authorization: token },
    // cancelToken,
  })

  return response
}

export const post_middleware_combined_search = async (
  path: string,
  body: any,
  token: string,
  cancelToken: CancelToken,
): Promise<AxiosResponse<IResponseService<any>>> => {
  const url = `bff/combined/${path}`
  const response = await axiosClientMiddleware.post<IResponseService<any>>(url, body, {
    headers: { "Content-Type": "application/json", Authorization: token },
    cancelToken,
  })

  return response
}

export const post_formdata_module_entity_action_middleware = async (
  group: OMNIX_MODULE,
  endpoint: string,
  body: any,
  token: string,
  cancelToken: CancelToken,
): Promise<AxiosResponse<IResponseService<any>>> => {
  const response = await axiosClientMiddleware.post<IResponseService<any>>(`bff/${group}/${endpoint}`, body, {
    headers: { "Content-Type": "multipart/form-data", Authorization: token },
    // cancelToken,
  })

  return response
}

export const post_module_orch_action_middleware = async (
  endpoint: string,
  body: any,
  token: string,
  cancelToken: CancelToken,
): Promise<AxiosResponse<IResponseService<any>>> => {
  const response = await axiosClientMiddleware.post<IResponseService<any>>(`orch/${endpoint}`, body, {
    headers: { "Content-Type": "application/json", Authorization: token },
    // cancelToken,
  })

  return response
}
